import { useState } from 'react';
import { useReactiveVar } from '@apollo/client';

import { didInfoVar } from '@store/index';
import useToggleCheckbox from '@hooks/useToggleCheckbox';
import { PLAYLIST_DATA, NOTICE_DATA } from '@lib/DUMMY';

import PlaylistSection from './PlaylistSection';

const Playlist = () => {
    const { version, type } = useReactiveVar(didInfoVar);
    const [imageLists, setImageLists] = useState<Record<string, any[]>>({});
    const [videoLists, setVideoLists] = useState<Record<string, any[]>>({});
    const [noticeLists, setNoticeLists] = useState<Record<string, any[]>>({});

    const { toggleCheckbox: toggleImage } = useToggleCheckbox(setImageLists);
    const { toggleCheckbox: toggleVideo } = useToggleCheckbox(setVideoLists);
    const { toggleCheckbox: toggleNotice } = useToggleCheckbox(setNoticeLists);

    // 헬로미디어 타입, 설정 유형 별 플레이리스트 분기
    const getHelloMediaType = () => {
        if (version === 1 && type === 1) {
            return [{ sectionIndex: 0, subTitle: '배너구간' }];
        } else if (version === 1 && type === 2) {
            return [
                { sectionIndex: 0, subTitle: '배너구간' },
                { sectionIndex: 1, subTitle: '배너구간' }
            ];
        } else if ((version === 1 && type === 3) || version === 3) {
            return [{ sectionIndex: 0, subTitle: '정방형구간' }];
        } else if ((version === 1 && type === 4) || version === 2) {
            return [{ sectionIndex: 0, subTitle: '전면구간' }];
        } else {
            return [];
        }
    };

    return (
        <>
            {getHelloMediaType().map((data, index) => (
                <PlaylistSection
                    key={`${index}-${data.subTitle}`}
                    sectionIndex={data.sectionIndex}
                    sectionSubTitle={data.subTitle}
                    imageLists={imageLists}
                    videoLists={videoLists}
                    noticeLists={noticeLists}
                    toggleImage={toggleImage}
                    toggleVideo={toggleVideo}
                    toggleNotice={toggleNotice}
                    imageData={PLAYLIST_DATA}
                    videoData={[]}
                    noticeData={NOTICE_DATA}
                />
            ))}
        </>
    );
};

export default Playlist;
